import slice from './cachedEntitiesSlice';

export * from './types';
export const {
  setCachedCohort,
  clearCachedCohort,
  clearCachedFunnel,
  setCachedFunnel,
  setNextStep,
  clearNextStep,
  setReplaceReport,
  clearReplaceReport,
  setCreateNewReport,
  clearCreateNewReport,
} = slice.actions;
export default slice.reducer;
